export { default } from './NumberCircle.styled'
export * from './NumberCircle.styled'
